import { render } from "./copy-icon.svg?vue&type=template&id=aaedc4f8"
import script from "./copy-icon.svg?vue&type=script&lang=js"
export * from "./copy-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3352/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__